import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmatonModalComponent } from '../components/confirmaton-modal/confirmaton-modal.component';
import { ConfirmationModalData } from '../models/confirmation-modal-data';
import { ModalWrapperData } from '../models/modal-wrapper-data.model';
import { ModalWrapperComponent } from './../components/modal-wrapper/modal-wrapper.component';

@Injectable({
  providedIn: 'root'
})
export class BaseModalService {

  private readonly defaultConfig: ModalWrapperData['config'] = {
    maxWidth: '40.4rem',
    panelClass: 'base-modal-custom-panel',
  };

  constructor(
    private dialog: MatDialog,
  ) { }

  showModal(modalData: ModalWrapperData) {
    const config = { ...this.defaultConfig, ...modalData.config };
    return this.dialog.open(ModalWrapperComponent, { data: modalData, ...config });
  }

  showConfirmationModal(confirmationModalData: ConfirmationModalData) {
    const { disableClose, ...data } = confirmationModalData;
    return this.dialog.open(ConfirmatonModalComponent, {
      data,
      disableClose,
      width: '100%',
      maxWidth: '40.375rem',
      autoFocus: false,
      panelClass: 'confirmation-modal-custom-panel',
    });
  }

  get dialogRef() {
    return this.dialog;
  }
}
